import RegisterCustomerStep6 from "./RegisterCustomerStep6";

export default function CustomerupPackageFlowStep3() {
    return (
        <RegisterCustomerStep6 />
    );
}